import Sidebar from "../../../components/layout/Sidebar/Sidebar";
function Email() {
    return (
        <div>Email</div>
    );
}

export default Email; 